import { useEffect, useState } from "react";
import { Check, ChevronsUpDown, Stethoscope, Plus } from "lucide-react";
import { cn } from "@/lib/utils";
import { Button } from "@/components/ui/button";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import {
  Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList,
} from "@/components/ui/command";
import { api } from "@/lib/api";

export default function SpecialtyCombobox({ value, onSelect }) {
  const [open, setOpen] = useState(false);
  const [options, setOptions] = useState([]);
  const [query, setQuery] = useState("");

  useEffect(() => {
    api.get("/specialties").then((r) => setOptions(r.data)).catch(() => {});
  }, []);

  const q = query.trim();
  const exact = options.some((o) => o.toLowerCase() === q.toLowerCase());

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          type="button"
          variant="outline"
          role="combobox"
          aria-expanded={open}
          data-testid="specialty-combobox"
          className="w-full justify-between rounded-xl border-[#E2E8F0] font-bold text-slate-700"
        >
          <span className="flex items-center gap-2 truncate">
            <Stethoscope className="h-4 w-4 shrink-0 text-[#0284C7]" />
            <span className="truncate">{value || "Selecciona una especialidad…"}</span>
          </span>
          <ChevronsUpDown className="ml-2 h-4 w-4 shrink-0 opacity-50" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-[--radix-popover-trigger-width] p-0" align="start">
        <Command>
          <CommandInput placeholder="Buscar especialidad…" value={query} onValueChange={setQuery} data-testid="specialty-search-input" />
          <CommandList>
            {q && !exact && (
              <CommandItem value={`__custom__${q}`} onSelect={() => { onSelect(q); setOpen(false); }} className="cursor-pointer" data-testid="specialty-custom-option">
                <Plus className="mr-2 h-4 w-4 text-[#0284C7]" />
                <span className="text-sm font-bold text-slate-800">Usar “{q}”</span>
              </CommandItem>
            )}
            <CommandEmpty>Escribe para agregar una especialidad.</CommandEmpty>
            <CommandGroup>
              {options.map((s) => (
                <CommandItem key={s} value={s} onSelect={() => { onSelect(s); setOpen(false); }} className="cursor-pointer" data-testid={`specialty-option-${s}`}>
                  <Check className={cn("mr-2 h-4 w-4", value === s ? "opacity-100 text-[#0284C7]" : "opacity-0")} />
                  <span className="text-sm font-bold text-slate-800">{s}</span>
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
}
